/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_First_Meeting_ContinueInputs */



/**
* | output |
* | --- |
* | "Go to your preparation" |
*
* @param {Onboarding_First_Meeting_ContinueInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_first_meeting_continue = /** @type {((inputs?: Onboarding_First_Meeting_ContinueInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_First_Meeting_ContinueInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Naar je gespreksvoorbereiding")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vers votre préparation")
	return /** @type {LocalizedString} */ ("Go to your preparation")
});